<template>
  <v-app class="po-layout-page">
    <PurchaseOrderBase
      :isShippingLabel="false"
    >
      <template v-slot:left="left">
        <PoLineItemsList
          :currentLineItemStatus="currentLineItemStatus"
          :loading="loading"
          :submitting="updating"
          :downloadingApproval="downloadingPdfMany"
          :lineSelectionDisabled="currentLineInfoLoading || actionsDisabled"
          :currentLineInfoLoading="currentLineInfoLoading"
          :items="poLineItems"
          :groupedItems="groupedLineItems"
          :poClients="clients"
          :isMyClient="isMyClient"
          :isMyEmployeeClient="isMyEmployeeClient"
          :poNumber="poNumber"
          @po-line-item-selected="currentLineItemChanged"
          @po-line-items-update-status="updateStatus"
          @po-line-items-report-issue="reportIssueAction"
          @po-line-items-download-approval="downloadApprovalMany"
          :show="left.showPoLineItemsList"
          @visibility-changed="left.onListVisibilityChanged"
          :displayCheckboxes="true"
          :displayActions="true"
          :routeName="'purchaseOrderDetails'"
        />
      </template>
      <slot/>
    </PurchaseOrderBase>
    <SatFooter />
  </v-app>
</template>

<script>

import SatFooter from '@/components/common/Footer.vue';
import PurchaseOrderBase from '@/layouts/PurchaseOrderBase.vue';
import PoLineItemsList from '@/components/PoDetails/SideBar/PoLineItemsList.vue';
import { mapState, mapActions, mapGetters } from 'vuex';
import PoDetailsConstants from '@/store/modules/poDetails/constants';
import SnackbarConstants from '@/store/modules/snackbarNotification/constants';

export default {
  components: {
    PoLineItemsList,
    PurchaseOrderBase,
    SatFooter,
  },
  data() {
    return {
      updating: false,
      downloadingPdfMany: false,
      issueReporting: false,
    };
  },
  computed: {
    ...mapState({
      loading: state => state.poDetails.loading,
      actionsDisabled: state => state.poDetails.actionsDisabled,
      clients: state => state.poDetails.clients,
      isMyClient: state => state.poDetails.isMyClient,
      isMyEmployeeClient: state => state.poDetails.isMyEmployeeClient,
      poNumber: state => state.poDetails.poNumber,
      poLineItems: state => state.poDetails.lineItems,
      groupedLineItems: state => state.poDetails.groupedLineItems,
      currentLineInfoLoading: state => state.poDetails.approvedImagesLoading
                                    || state.poDetails.uploadedImagesLoading
                                    || state.poDetails.activityLoading,
    }),
    ...mapGetters('poDetails', {
      currentLineItemStatus: PoDetailsConstants.getterTypes.currentLineItemStatus,
      imagesCount: PoDetailsConstants.getterTypes.currentLineItemImagesCount,
      currentLineItem: PoDetailsConstants.getterTypes.currentLineItemInfo,
    }),
    currentUrl() {
      return this.$route.fullPath;
    },
  },
  methods: {
    updateStatus(lineItemIds, newStatus, notes) {
      const updateInfo = {
        lineItemIds,
        newStatus,
        notes,
        poDetailsLink: this.currentUrl,
        currentLineItemId: this.getCurrentLineItemId(),
      };

      this.updating = true;

      this.updateLineItemsStatus(updateInfo)
        .then((submittedCount) => {
          this.successNotification(`${submittedCount} line item(s) status was updated.`);
        })
        .finally(() => {
          this.updating = false;
        });
    },
    getCurrentLineItemId() {
      return this.currentLineItem.lineItems[0].id;
    },
    downloadApprovalMany(lineItemIds) {
      const self = this;
      this.downloadingPdfMany = true;
      this.getApprovalDocument({
        lineItemIds,
      })
        .then((response) => {
          this.$downloadBlob(response.pdfBlob, response.fileName);
        })
        .finally(() => {
          self.downloadingPdfMany = false;
        });
    },
    reportIssueAction(lineItemIds, data, notes) {
      this.issueReporting = true;
      this.updating = true;

      this.reportIssue({
        lineItemIds,
        notes,
        poDetailsLink: this.currentUrl,
        currentLineItemId: this.getCurrentLineItemId(),
      })
        .then((reportedCount) => {
          this.successNotification(`Reported issue for ${reportedCount} line item(s)`);
        }).finally(() => {
          this.issueReporting = false;
          this.updating = false;
        });
    },
    ...mapActions('poDetails', {
      currentLineItemChanged: PoDetailsConstants.actionTypes.onCurrentLineItemChanged,
      updateLineItemsStatus: PoDetailsConstants.actionTypes.updateLineItemsStatus,
      getApprovalDocument: PoDetailsConstants.actionTypes.getApprovalDocument,
      reportIssue: PoDetailsConstants.actionTypes.reportIssue,
    }),
    ...mapActions('snackbarNotification', {
      successNotification: SnackbarConstants.actionTypes.success,
    }),
  },
};
</script>

<style lang="scss">
  .po-layout-page{
    main{
      background: #f2f2f2;
    }

    .po-toolbar-title {
      width: 100%;
    }
  }

  .v-toolbar__extension {
    background: #039BE5;
  }
</style>
